import React from 'react';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { AuditionType } from 'shared/enums/AuditionType';
import { ICastingRoleAttributes } from 'shared/interfaces/ICastingRole';
import { auditionTypeParser } from 'shared/utils/room-shared';
import { useStyles } from '../Role.styles';

type Props = {
  data: ICastingRoleAttributes | undefined;
};

const Head: React.FC<Props> = ({ data }) => {
  const classes = useStyles();

  const parseAuditionType = (type: string) => {
    switch (type) {
      case 'virtual':
        return 'Virtual';
      case 'self-tape':
        return 'Self Tape';
      default:
        return 'Studio';
    }
  };

  return (
    <div>
      <CustomTypography fontSize={18}>Role Name: {data?.name || '–'}</CustomTypography>
      <div className={classes.miniRow}>
        <CustomTypography fontSize={13} fontWeight={600}>
          Audition Type:
        </CustomTypography>
        <CustomTypography fontSize={13}>
          {data?.audition?.audition_type?.map((type) => parseAuditionType(type)).join(', ') ||
            auditionTypeParser((data?.audition_type as AuditionType) || '–')}
        </CustomTypography>
        <CustomTypography fontSize={13} fontWeight={600}>
          Role Type:
        </CustomTypography>
        <CustomTypography fontSize={13}>
          {data?.principal_role_type || data?.background_role_type
            ? data?.principal_role_type
              ? data?.principal_role_type
              : data?.background_role_type
            : '–'}
        </CustomTypography>
        <CustomTypography fontSize={13} fontWeight={600}>
          Spot Name:
        </CustomTypography>
        <CustomTypography fontSize={13}>{data?.spot_name || '–'}</CustomTypography>
        <CustomTypography fontSize={13} fontWeight={600}>
          For:
        </CustomTypography>
        <CustomTypography fontSize={13} className={classes.miniRow}>
          <CustomTypography fontSize={13}>
            {data && data?.role_is_for?.length > 0
              ? data?.role_is_for.map((i: string, _) => (
                  <React.Fragment>{data?.role_is_for.length === _ + 1 ? i : `${i}, `}</React.Fragment>
                ))
              : '–'}
          </CustomTypography>
        </CustomTypography>
      </div>
    </div>
  );
};

export default Head;
